import {ChronoUnitLegacy} from "./time-utils";
import {ChronoUnit, convert, Instant, LocalDateTime, nativeJs, ZoneOffset} from "@js-joda/core";

export namespace JodaTimeUtils {
    const validHandledUnitsInFunctions = [
        ChronoUnit.MILLIS,
        ChronoUnit.SECONDS,
        ChronoUnit.MINUTES,
        ChronoUnit.HOURS,
        ChronoUnit.DAYS,
        ChronoUnit.WEEKS,
        ChronoUnit.MONTHS,
        ChronoUnit.YEARS
    ];

    export function convertLegacyChronoUnitToJoda(legacyUnit: ChronoUnitLegacy): ChronoUnit {
        const unitName = ChronoUnitLegacy[legacyUnit];
        if (!unitName) {
            throw new Error('Unsupported CHRONOS Unit Legacy value');
        }

        return ChronoUnit[unitName]
    }

    const anyDateToLocalDateTime = (date: LocalDateTime | Date | string): LocalDateTime => {
        return date instanceof LocalDateTime ? date : UTCDateToLocalDateTime(date);
    }

    const UTCDateToLocalDateTime = (date: Date | string): LocalDateTime => {
        if (date instanceof Date) {
            return LocalDateTime.from(nativeJs(date));
        }
        return LocalDateTime.ofInstant(Instant.parse(date), ZoneOffset.UTC);
    }

    const LocalDateTimeToJSDate = (date: LocalDateTime): Date => {
        return convert(date).toDate();
    }

    export const truncateTo = (date: LocalDateTime | Date | string, unit: ChronoUnit): Date => {
        if (!validHandledUnitsInFunctions.includes(unit)) {
            throw new Error('Unhandled time unit.');
        }

        const tempDate = anyDateToLocalDateTime(date);

        const switchFunction = (unit: ChronoUnit): LocalDateTime => {
            switch (unit) {
                case ChronoUnit.MILLIS:
                case ChronoUnit.SECONDS:
                case ChronoUnit.MINUTES:
                case ChronoUnit.HOURS:
                case ChronoUnit.DAYS:
                    return tempDate.truncatedTo(unit);
                case ChronoUnit.WEEKS:
                    return tempDate.truncatedTo(ChronoUnit.DAYS).minusDays(tempDate.dayOfWeek().value() === 0 ? 6 : tempDate.dayOfWeek().value() - 1);
                case ChronoUnit.MONTHS:
                    return tempDate.truncatedTo(ChronoUnit.DAYS).withDayOfMonth(1);
                case ChronoUnit.YEARS:
                    return tempDate.truncatedTo(ChronoUnit.DAYS).withDayOfMonth(1).withMonth(1);
                default:
                    throw new Error('Unhandled time unit.');
            }
        }

        return LocalDateTimeToJSDate(switchFunction(unit));
    }

    export const CeilingTo = (date: LocalDateTime | Date | string, unit: ChronoUnit): Date => {
        if (!validHandledUnitsInFunctions.includes(unit)) {
            throw new Error('Unhandled time unit.');
        }

        const tempDate = anyDateToLocalDateTime(date);
        const truncatedDate = anyDateToLocalDateTime(JodaTimeUtils.truncateTo(tempDate, unit));

        const switchFunction = (unit: ChronoUnit): LocalDateTime => {
            switch (unit) {
                case ChronoUnit.MILLIS:
                case ChronoUnit.SECONDS:
                case ChronoUnit.MINUTES:
                case ChronoUnit.HOURS:
                case ChronoUnit.DAYS:
                case ChronoUnit.WEEKS:
                case ChronoUnit.MONTHS:
                case ChronoUnit.YEARS:
                    if (truncatedDate.isBefore(tempDate)) {
                        return truncatedDate.plus(1, unit);
                    }
                    return truncatedDate;
                default:
                    throw new Error('Unhandled time unit.');
            }
        };

        return LocalDateTimeToJSDate(switchFunction(unit));
    };
}

